var Education = "Istruzione";
var Enterprise = "Grande impresa";
var CompanyType = {
	"Company type": "Tipo di azienda",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Governo - federale",
	"Government - State & local": "Governo - statale e locale",
	"Non-profit": "No profit",
	"Self employed": "Lavoratore autonomo",
	"Small-medium business": "Piccole e medie imprese",
	"Start-up": "Start-up",
	"Not applicable": "Non applicabile"
};

export { Education, Enterprise, CompanyType as default };
